import {
  Stack,
  Flex,
  Button,
  Text,
  VStack,
  useBreakpointValue,
  Heading,
  Box,
} from "@chakra-ui/react";
import Image from "next/image";
import Router from "next/router";
import { FiArrowRight } from "react-icons/fi";

export default function LandingHero() {
  const heroPx = useBreakpointValue({ base: 6, md: 8 });

  return (
    <Flex
      w="full"
      minH="100vh"
      position="relative"
      overflow="hidden"
      bg="#0a0f1a"
    >
      {/* Background image */}
      <Image
        src="/img/landing/12.jpg"
        alt=""
        fill
        priority
        quality={60}
        sizes="100vw"
        style={{ objectFit: "cover", objectPosition: "center" }}
      />

      {/* Single dark overlay for text readability */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0, 0, 0, 0.6)"
      />

      <VStack
        w="full"
        justify="center"
        px={heroPx}
        minH="100vh"
        position="relative"
        zIndex={1}
      >
        <Stack maxW="3xl" align="center" spacing={{ base: 8, md: 10 }}>
          <Heading
            color="white"
            fontWeight={700}
            fontSize={{ base: "4xl", sm: "5xl", md: "7xl", lg: "8xl" }}
            lineHeight="1.1"
            textAlign="center"
            letterSpacing="-0.02em"
          >
            Safety Alerts
            <br />
            <Text as="span" color="brand.500">
              Everywhere
            </Text>
          </Heading>

          <Text
            color="text.on-black-secondary"
            maxW="2xl"
            textAlign="center"
            fontSize={{ base: "lg", md: "xl" }}
            lineHeight="1.8"
          >
            Supercharge your Garmin inReach, ZOLEO, or Bivy Stick—transforming
            it into a personal safety radar that gives you early warnings when
            it matters most.
          </Text>

          <Flex
            direction={{ base: "column", sm: "row" }}
            gap={4}
            wrap="wrap"
            justify="center"
            pt={2}
          >
            <Button
              size="lg"
              bg="brand.500"
              color="white"
              px={8}
              py={7}
              fontSize="md"
              fontWeight={600}
              borderRadius="md"
              _hover={{
                bg: "brand.800",
                transform: "translateY(-1px)",
              }}
              transition="transform 0.2s ease, background-color 0.2s ease"
              onClick={() => Router.push("/login")}
              rightIcon={<FiArrowRight />}
            >
              Get Started Free
            </Button>
            <Button
              size="lg"
              bg="transparent"
              color="white"
              px={8}
              py={7}
              fontSize="md"
              fontWeight={600}
              borderRadius="md"
              border="1px solid rgba(255, 255, 255, 0.3)"
              _hover={{
                bg: "rgba(255, 255, 255, 0.08)",
                borderColor: "rgba(255, 255, 255, 0.5)",
              }}
              transition="background-color 0.2s ease, border-color 0.2s ease"
              onClick={() => Router.push("/how-it-works")}
            >
              How It Works
            </Button>
          </Flex>
        </Stack>
      </VStack>
    </Flex>
  );
}
